import React, { useEffect, useCallback } from "react";
import "./WalletCustomerInfo.scss";
import Pagination from "@mui/material/Pagination";
import { useState } from "react";
// import { getAllWalletInfo } from "../../../services/utilsWallet";
import {getAllWalletInfoByDate} from "../../../services/utilsWallet";
// import DefaultImg from "../../../assets/market-icons/avatar-supervisor.jpg";
// import WalletIcon from "@mui/icons-material/Wallet";
// import PendingIcon from "@mui/icons-material/Pending";
// import UndoIcon from "@mui/icons-material/Undo";
// import ClearIcon from "@mui/icons-material/Clear";
import WalletTransaction from "./WalletTransaction";
import WalletPayIn from "./WalletPayIn";

const WalletCustomerInfo = (props) => {
  const { setWalletInfo, selectedWallet } = props;

  const [currentPage, setCurrentPage] = useState(1);

  // const [movements, setMovements] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState("ultimos30dias");
  const [allMovements, setAllMovements] = useState([]); 
  const [displayedMovements, setDisplayedMovements] = useState([]); 
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  
  const ITEMS_PER_PAGE = 6;

  // Get current year and previous year for dynamic filters
  const currentYear = new Date().getFullYear();
  const previousYear = currentYear - 1;

  // const formatMoney = (number) => {
  //   return new Intl.NumberFormat("es-MX", {
  //     style: "currency",
  //     currency: "MXN",
  //     minimumFractionDigits: 0,
  //     maximumFractionDigits: 0,
  //   }).format(number);
  // };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // const handlePageChange = (event, newPage) => {
  //   let fkOrganization = localStorage.getItem("fk_organization");
  //   setCurrentPage(newPage);
  //   getAllWalletInfo(
  //     fkOrganization,
  //     newPage,
  //     6,
  //     selectedWallet.wallet_type,
  //     selectedWallet.id
  //   ).then((data) => {
  //     setMovements(data.wallet_movements);
  //   });
  // };

  // Aply filters
  const applyDateFilter = useCallback((filterValue) => {
    if (!selectedWallet) return;
    
    const fkOrganization = localStorage.getItem("fk_organization");
    let startDate, endDate;
    
    // Create a new date for each calculation to avoid secondary effects
    // const currentDate = new Date();
    
    // Calculate dates according to the selected filter
    switch (filterValue) {
      case "ultimos30dias": {
        endDate = formatDate(new Date());
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        startDate = formatDate(thirtyDaysAgo);
        break;
      }
      case "ultimos3meses": {
        endDate = formatDate(new Date());
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        startDate = formatDate(threeMonthsAgo);
        break;
      }
      case "currentYear": {
        startDate = `${currentYear}-01-01`;
        endDate = `${currentYear}-12-31`;
        break;
      }
      case "previousYear": {
        startDate = `${previousYear}-01-01`;
        endDate = `${previousYear}-12-31`;
        break;
      }
      default: {
        // By default, last 30 days
        endDate = formatDate(new Date());
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        startDate = formatDate(thirtyDaysAgo);
      }
    }
    
    // console.log(`Aplicando filtro: ${filterValue} - Desde: ${startDate} Hasta: ${endDate}`);
    
    // Activate loading state
    setIsLoading(true);
    
    // Call the service with the calculated dates
    getAllWalletInfoByDate(
      fkOrganization,
      selectedWallet.wallet_type,
      selectedWallet.id,
      startDate,
      endDate
    ).then((data) => {
      // console.log("Datos recibidos:", data);
      // Save all movements
      const movements = data.wallet_movements || [];
      
      // Eliminar duplicados basados en idempotence_key o id
      const uniqueMovements = movements.reduce((acc, current) => {
        const key = current.idempotence_key || current.id;
        if (!acc.some(item => (item.idempotence_key || item.id) === key)) {
          acc.push(current);
        }
        return acc;
      }, []);
      
      // console.log("Movimientos únicos:", uniqueMovements.length);
      // console.log("Movimientos originales:", movements.length);
      
      setAllMovements(uniqueMovements);
      
      // Calculate total number of pages
      const pages = Math.ceil(uniqueMovements.length / ITEMS_PER_PAGE);
      setTotalPages(pages > 0 ? pages : 1);
      
      // Reset to the first page when the filter changes
      setCurrentPage(1);
      
      // Update the view with the first page of results
      updateDisplayedMovements(uniqueMovements, 1);
      
      // update walletInfo if necessary
      setWalletInfo(prevInfo => ({
        ...prevInfo,
        wallet_movements: uniqueMovements
      }));
    }).catch(error => {
      // console.error("Error al obtener movimientos:", error);
      setAllMovements([]);
      setDisplayedMovements([]);
      setTotalPages(1);
    }).finally(() => {
      // Disable loading state when the operation is finished
      setIsLoading(false);
    });
  }, [selectedWallet, currentYear, previousYear, setWalletInfo]);

  // Function to update the displayed movements according to the current page
  const updateDisplayedMovements = (movements, page) => {
    if (!movements || movements.length === 0) {
      setDisplayedMovements([]);
      return;
    }

    const startIndex = (page - 1) * ITEMS_PER_PAGE;
    const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, movements.length);
    
    if (startIndex >= movements.length) {
      setDisplayedMovements([]);
      return;
    }

    const pageMovements = movements.slice(startIndex, endIndex);
    // console.log(`Página ${page}: Mostrando movimientos del ${startIndex + 1} al ${endIndex}`);
    // console.log("Movimientos en esta página:", pageMovements.map(m => m.idempotence_key || m.id));
    setDisplayedMovements(pageMovements);
  };

  const handleDateFilterChange = (event) => {
    const newFilter = event.target.value;
    // console.log("Selected filter:", newFilter);
    setSelectedFilter(newFilter);
    applyDateFilter(newFilter);
  };

  const handlePageChange = (event, newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    updateDisplayedMovements(allMovements, newPage);
  };

    // Effect to load initial data when the component is mounted or selectedWallet changes
  useEffect(() => {
    if (selectedWallet && Object.keys(selectedWallet).length > 0) {
      // console.log("Wallet selected changed, applying default filter:", selectedFilter);
      applyDateFilter(selectedFilter);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWallet, applyDateFilter]);


return (
  <div className="wallet-customer-info">
    <div className="wallet-movements-list">
      <li className="wallet-mov-text">Movimientos de Billetera</li>
      <div className="wallet-date-filters">
        <span className="filter-prefix-text">Filtrar por </span>
        <select 
          className="date-filter-dropdown" 
          value={selectedFilter}
          onChange={handleDateFilterChange}
          disabled={isLoading}
        >
          <option value="ultimos30dias">Últimos 30 días</option>
          <option value="ultimos3meses">Últimos 3 meses</option>
          <option value="currentYear">{currentYear}</option>
          <option value="previousYear">{previousYear}</option>
        </select>
      </div>
      
      {/* Loading indicator */}
      {isLoading && (
        <div className="loading-container">
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
          <p className="loading-text">Cargando movimientos...</p>
        </div>
      )}
      
      {/* Show movements only when not loading */}
      {!isLoading && (
        <>
          {displayedMovements && displayedMovements.length > 0 ? (
            displayedMovements.map((movement) => (
              <div key={movement.idempotence_key || movement.id}>
                {movement.type === "transaction" ? (
                  <WalletTransaction movement={movement} />
                ) : (
                  <WalletPayIn movement={movement} />
                )}
              </div>
            ))
          ) : (
            <div className="no-movements">No hay movimientos para mostrar en este período</div>
          )}
        </>
      )}
    </div>
    
    {/* Show pagination only when not loading and there are more than one page */}
    {!isLoading && totalPages > 1 && (
      <Pagination
        count={totalPages}
        color="primary"
        page={currentPage}
        onChange={handlePageChange}
        className="pagination"
      />
    )}
  </div>
);
};

export default WalletCustomerInfo;
